import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import 'rxjs/add/operator/map';
import { Globals } from "../../globals";;
import { HttpClient } from '@angular/common/http';


@Injectable()
export class AddonsServices {

  public addon_id: any;
  public payment_state: any;

  constructor(public afs: AngularFirestore,
    public globals: Globals,
    private http: HttpClient) {

  }

  paymentOK(payment_method, extra) {
    this.sendSlackMethodPayment(payment_method, this.addon_id, extra);
    this.openAddon(this.addon_id);
    //this.sendSlackMethodPayment(payment_method, this.addon_id, extra);
  }

  openAddon(addon_id) {

  }

  async sendSlackMethodPayment(payment_method, addon_id, extra) {
    //Funcion que envia a slack la venta.
    //Extra para IBAN number

    var msg;
    //Switch case??
    msg = 'Compra:' + addon_id + ' Cliente:' + this.globals.restaurant.email;
    if (payment_method == 'stripe') {
      msg = msg + ' Metodo: Stripe';
    } else if (payment_method == 'iban') {
      msg = msg + ' Metodo: IBAN ' + extra;
    } else if (payment_method == 'inapp') {
      msg = msg + ' Metodo: InAppPurchase ' + extra;
    }
    //Inn app

    //send
    await this.http.post(this.globals.api_path + 'slack/method_payment', {
      msg: msg,
    }, {}).subscribe(async data => {
    },
      err => {
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/addons/services.ts